export enum PermissionLevel {
  CreatedByUser = 0,
  CreatedByEntireOrganization = 1
}
